import React from 'react';
import { Store } from 'redux';
import { Routes, Navigate, Route } from 'react-router-dom';
import CoreLayout from '@client/layouts/core';
import GuestLayout from '@client/layouts/guest';
import { PAGE_ROUTES } from '@shared/routes';
import { useNewDealsToday } from '@client/components/mylounge/new-deals-today';
import { NewDealsToday } from '@client/views/new-deals-today';
import MyLounge from '../views/mylounge';

import { GenericErrorPage } from '../views/genericErrorPage';

// TODO: fix typing
type ReduxStore = Store<any>;

interface MakedRoutesProps {
    isLoggedIn: boolean;
}

const MakedRoutes = ({ isLoggedIn }: MakedRoutesProps) => {
    const Layout = isLoggedIn ? CoreLayout : GuestLayout;
    const { isNewDealsTodayVariant } = useNewDealsToday();

    return (
        <Routes>
            <Route element={<Layout />}>
                <Route
                    path={PAGE_ROUTES.NewDeals}
                    element={isNewDealsTodayVariant ? <NewDealsToday /> : <Navigate to="/event" />}
                />
                <Route path={PAGE_ROUTES.MyLounge} element={<MyLounge />} />
                <Route path={PAGE_ROUTES.ErrorPage} element={<GenericErrorPage />} />
                <Route path="*" element={<Navigate to="/event" />} />
            </Route>
        </Routes>
    );
};

export default MakedRoutes;
